/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OfferRegionEnum = 'EMEA' | 'APAC' | 'NA';

export const OfferRegionEnum = {

    EMEA: 'EMEA' as OfferRegionEnum,

    APAC: 'APAC' as OfferRegionEnum,

    NA: 'NA' as OfferRegionEnum
};

